import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const ClipboardHouse = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.9028 4.47364H3.82629C3.61619 4.47364 3.44588 4.64395 3.44588 4.85404V12.3516C3.44588 12.5617 3.61619 12.732 3.82629 12.732H7.49612C7.84627 12.732 8.13013 13.0158 8.13013 13.366C8.13013 13.7161 7.84627 14 7.49612 14H3.82629C2.91588 14 2.17786 13.262 2.17786 12.3516V4.85404C2.17786 3.94364 2.91589 3.20561 3.82629 3.20561H4.80749C5.00095 2.51027 5.63877 2 6.39577 2H9.03138C9.78838 2 10.4262 2.51027 10.6197 3.20561H11.6203C12.5307 3.20561 13.2688 3.94364 13.2688 4.85404V8.04941C13.2688 8.39956 12.9849 8.68342 12.6348 8.68342C12.2846 8.68342 12.0008 8.39956 12.0008 8.04941V4.85404C12.0008 4.64395 11.8304 4.47364 11.6203 4.47364H10.5244C10.2612 5.03418 9.6916 5.42232 9.03138 5.42232H6.39577C5.73554 5.42232 5.16597 5.03418 4.9028 4.47364ZM6.01536 3.64843C6.01536 3.43834 6.18568 3.26802 6.39577 3.26802H9.03138C9.24147 3.26802 9.41179 3.43834 9.41179 3.64843V3.77389C9.41179 3.98398 9.24147 4.1543 9.03138 4.1543H6.39577C6.18568 4.1543 6.01536 3.98398 6.01536 3.77389V3.64843Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7852 9.18125C11.0877 8.93527 11.52 8.93073 11.8276 9.17032L13.4996 10.4727C13.7031 10.6313 13.8222 10.8749 13.8222 11.1329V13.0248C13.8222 13.487 13.4475 13.8616 12.9853 13.8616H9.71497C9.25277 13.8616 8.87808 13.487 8.87808 13.0248V11.1303C8.87808 10.8784 8.99153 10.6399 9.18695 10.481L10.7852 9.18125ZM11.3191 10.3815L10.1461 11.3354V12.5936H12.5541V11.3436L11.3191 10.3815Z"
        fill="currentColor"
      />
      <path
        d="M5.85803 7.35777C5.85803 7.72945 5.55673 8.03075 5.18505 8.03075C4.81337 8.03075 4.51206 7.72945 4.51206 7.35777C4.51206 6.98609 4.81337 6.68479 5.18505 6.68479C5.55673 6.68479 5.85803 6.98609 5.85803 7.35777Z"
        fill="currentColor"
      />
      <path
        d="M5.85803 9.74926C5.85803 10.1209 5.55673 10.4222 5.18505 10.4222C4.81337 10.4222 4.51206 10.1209 4.51206 9.74926C4.51206 9.37758 4.81337 9.07628 5.18505 9.07628C5.55673 9.07628 5.85803 9.37758 5.85803 9.74926Z"
        fill="currentColor"
      />
      <path
        d="M6.22563 9.74925C6.22563 9.39909 6.50948 9.11524 6.85964 9.11524H7.89137C8.24152 9.11524 8.52538 9.39909 8.52538 9.74925C8.52538 10.0994 8.24152 10.3833 7.89137 10.3833H6.85964C6.50948 10.3833 6.22563 10.0994 6.22563 9.74925Z"
        fill="currentColor"
      />
      <path
        d="M6.85964 6.72376C6.50948 6.72376 6.22563 7.00762 6.22563 7.35777C6.22563 7.70793 6.50948 7.99179 6.85964 7.99179H10.3026C10.6528 7.99179 10.9366 7.70793 10.9366 7.35777C10.9366 7.00762 10.6528 6.72376 10.3026 6.72376H6.85964Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default ClipboardHouse;
